"use client";
import React, { useState } from "react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { Box, Button, Flex } from "@chakra-ui/react";
import BareMetalTables from "app/pricing/hostedEmulatorsTable/bareMetal";
import BareMetalClusterTable from "app/pricing/hostedEmulatorsTable/bareMetalCluster";

const PricingTable = () => {
  const [selectedOption, setSelectedOption] = useState("Baremetal");
  const handleClick = (option) => {
    setSelectedOption(option);
  };

  return (
    <Box data-cy="section-bm-pricing" id="section-pricing">
      <SectionDivider label={"Bare Metal Pricing"} />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={"15px"}
        justifyContent={"center"}
      >
        <Button
          onClick={() => handleClick("Baremetal")}
          width={{ base: "100%", md: "45%" }}
          height={"55px"}
          color={selectedOption === "Baremetal" ? "black" : "white"}
          bgColor={selectedOption === "Baremetal" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Baremetal</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
        <Button
          onClick={() => handleClick("Baremetal Cluster")}
          width={{ base: "100%", md: "45%" }}
          height={"55px"}
          color={selectedOption === "Baremetal Cluster" ? "black" : "white"}
          bgColor={selectedOption === "Baremetal Cluster" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Baremetal Cluster</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
      </Flex>
      {selectedOption === "Baremetal" && <BareMetalTables />}
      {selectedOption === "Baremetal Cluster" && <BareMetalClusterTable />}
    </Box>
  );
};

export default PricingTable;
